interface BillingToggleProps {
  isAnnual: boolean
  onToggle: () => void
}

export function BillingToggle({ isAnnual, onToggle }: BillingToggleProps) {
  return (
    <button onClick={onToggle} className="flex items-center gap-1.5 mt-1">
      <div className="size-1.5 rounded-full bg-[#555]" />
      <span className="text-xs text-[#555]">
        {isAnnual ? 'Billed annually' : 'Billed monthly'}
      </span>
    </button>
  )
}
